import { useCallback, useMemo } from "react";

import { useAtom } from "jotai";

import { type DataColumn } from "@features/mmm/components/explore-budgets/client-setting/types";

import {
  ClientDataColumnsAtom,
  ClientLegacyDataColumnsAtom,
  useGlobalMMMStore,
} from "../mmm-provider";

export const useClientDataColumns = () => {
  const GlobalMMMStore = useGlobalMMMStore();
  const [clientDataColumns, setClientDataColumns] = useAtom(
    ClientDataColumnsAtom,
    { store: GlobalMMMStore },
  );

  // TODO DEPRECATE
  const [clientLegacyDataColumns, setClientLegacyDataColumns] = useAtom(
    ClientLegacyDataColumnsAtom,
    { store: GlobalMMMStore },
  );

  const dataColumnColumnNameMap = useMemo(() => {
    return new Map<string, DataColumn>(
      clientDataColumns.map((dataColumn) => {
        return [dataColumn.column_name, dataColumn];
      }),
    );
  }, [clientDataColumns]);

  const getCycleDataColumnByColumnName = useCallback(
    (columnName: string) => {
      return dataColumnColumnNameMap.get(columnName);
    },
    [dataColumnColumnNameMap],
  );

  return {
    clientDataColumns,
    setClientDataColumns,
    clientLegacyDataColumns,
    setClientLegacyDataColumns,
    getCycleDataColumnByColumnName,
  };
};
